import { Reset, Theme } from "@bluframe/blublocks"
import Typography from "components/Typography"
import { rgba } from "polished"
import styled from "styled-components"

const ERROR_ALPHA = 0.14
const ACTION_WIDTH = 200

export const Wrapper = styled.div`
  background-color: ${({ theme }: { theme: Theme }) =>
    theme.palette.text.contrast};
  display: grid;
  padding: 20px;
  width: 100%;
`

export const TriggersUl = styled(Reset.Ul)`
  display: grid;
  row-gap: 16px;
`

export const TriggerLi = styled(Reset.Li)``

export const TriggerCard = styled.div`
  display: grid;
  padding: 0;
`

export const TriggerHeader = styled.div`
  align-items: start;
  column-gap: 36px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) ${ACTION_WIDTH}px;
`

export const TriggerFooter = styled.div`
  display: grid;
  margin-top: 12px;
  row-gap: 4px;
`

export const TriggerTitle = styled(Typography.H4)`
  margin: 0;
`

export const TriggerMeta = styled.div`
  display: grid;
  row-gap: 4px;
`

export const TriggerStatus = styled(Typography.SubtitleH3)`
  margin: 0;
`

export const TriggerError = styled(TriggerStatus)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.error.main};
`

export const DisabledReason = styled(TriggerStatus)`
  color: ${({ theme }: { theme: Theme }) =>
    rgba(theme.palette.text.main, ERROR_ALPHA)};
`

export const TriggerHint = styled(TriggerStatus)`
  color: ${({ theme }: { theme: Theme }) =>
    rgba(theme.palette.text.main, ERROR_ALPHA)};
`
